import * as moment from 'moment';

export class Accomodation {
    checkinDate: moment.Moment;
    checkoutDate: moment.Moment;
    arrivalAirportCode: string;
    bookingCurrencyCode: string;
    language: string;
    dateFormat: string;
}